module.exports = __webpack_public_path__ + "img/img-empty.5a854ef2.png";